/**
 * The states Lunex Direct will price a system in.
 *
 * One list, two readers: `Locate` gates the Next button on it, and `StoryPanel`
 * prints it on the landing panel. Keeping a second hand-typed copy next to the
 * one that gates the form is how a state ends up advertised but unbuyable, or
 * bought but unsupported.
 */
export const SERVED_STATES = ['FL', 'MA', 'RI', 'CT', 'CO', 'NC'];

export default SERVED_STATES;
